"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _useSingleImageUrl = _interopRequireDefault(require("./useSingleImageUrl"));
var _default = _useSingleImageUrl["default"];
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTaW5nbGVJbWFnZVVybCJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91c2VTaW5nbGVJbWFnZVVybC9pbmRleC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlU2luZ2xlSW1hZ2VVcmwgZnJvbSAnLi91c2VTaW5nbGVJbWFnZVVybCc7XG5cbmV4cG9ydCBkZWZhdWx0IHVzZVNpbmdsZUltYWdlVXJsO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUFBO0FBQW9ELGVBRXJDQSw2QkFBaUI7QUFBQSJ9